import { useCallback, useMemo } from 'react'
import { useFormikContext } from 'formik'
import type { CustomFieldFormModel } from '../../../typings'
import type { DropdownOptionProps } from '../DropdownOption'

export function useOptionActions(props: DropdownOptionProps) {
  const { index, onRemove } = props

  const {
    setFieldValue,
    values: { options },
    errors: { options: optionErrors },
  } = useFormikContext<CustomFieldFormModel>()

  const option = options[index]
  const fieldName = `options[${index}]`

  const optionError = useMemo(() => {
    if (Array.isArray(optionErrors)) {
      const err = optionErrors[index]
      if (typeof err === 'string') {
        return err
      }
    }
  }, [index, optionErrors])

  const onChangeName = useCallback(
    (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) =>
      setFieldValue(`${fieldName}.name`, event.target.value),
    [fieldName, setFieldValue],
  )

  const onChangeActive = useCallback(
    (_e, checked: boolean) => setFieldValue(`${fieldName}.active`, checked),
    [fieldName, setFieldValue],
  )

  const onClickRemove = useCallback(() => onRemove(index), [index, onRemove])

  return {
    option,
    optionError,
    onChangeName,
    onClickRemove,
    onChangeActive,
  }
}
